<div class="container" [ngClass]="{'show': show}" [ngStyle]='{"width":(width) +"px"}' (click)="onClick($event)"
    (mousedown)="onClick($event)" (clickOutside)="onClickOutside($event)">
    <ng-template #Container></ng-template>
</div>